import Cookies from "js-cookie";

initHeader();
function initHeader() {
  // Set header height to global css var
  const header = document.querySelector("#header");
  if (!header) return;

  // Resizer observer
  headerHeight();
  function headerHeight() {
    const root = document.documentElement;
    const nav = header.querySelector(".top-section");
    const footer = document.querySelector("footer.footer");

    if (!nav) return;

    const setHeaderHeight = () => {
      root.style.setProperty("--header", nav.offsetHeight + "px");
      root.style.setProperty("--footer", footer.offsetHeight + "px");
    };

    const resizer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setHeaderHeight();
      }
    });
    resizer.observe(nav);
  }

  // Toggle scroll direction classes on <body>
  initScrollDirectionClasses();
  function initScrollDirectionClasses() {
    const body = document.body;
    if (!body) return;

    let lastScrollY = window.scrollY;
    let ticking = false;
    const SCROLL_DELTA_THRESHOLD = 4;

    const setDirectionClass = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY <= 0) {
        body.classList.remove("is-scrolling--up", "is-scrolling--down");
        lastScrollY = currentScrollY;
        return;
      }

      const delta = currentScrollY - lastScrollY;

      if (Math.abs(delta) <= SCROLL_DELTA_THRESHOLD) return;

      if (delta > 0) {
        body.classList.add("is-scrolling--down");
        body.classList.remove("is-scrolling--up");
      } else {
        body.classList.add("is-scrolling--up");
        body.classList.remove("is-scrolling--down");
      }

      lastScrollY = currentScrollY;
    };

    setDirectionClass();

    window.addEventListener(
      "scroll",
      () => {
        if (ticking) return;

        ticking = true;
        window.requestAnimationFrame(() => {
          setDirectionClass();
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  // Set up subnavs
  initSubnavs();
  function initSubnavs() {
    const btns = header.querySelectorAll("[subnav-btn]");
    const subnavsOuter = header.querySelector(".subnavs");
    const subnavs = header.querySelectorAll(".subnav");
    let closeTimer;
    const CLOSE_DELAY = 120;

    if (!subnavs.length) return;

    const setPanelHeight = (panel) => {
      const links = panel.querySelector(".subnav-links");
      if (!links) return;
      panel.style.setProperty("--subnav-height", links.scrollHeight + "px");
    };

    // Set accordion height with resizeObserver
    const resizer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const panel = entry.target.closest(".subnav");
        if (panel) setPanelHeight(panel);
      }
    });

    subnavs.forEach((subnav) => {
      setPanelHeight(subnav);
      const links = subnav.querySelector(".subnav-links");
      if (links) resizer.observe(links);
    });

    const clearCloseTimer = () => {
      if (!closeTimer) return;
      window.clearTimeout(closeTimer);
      closeTimer = null;
    };

    const collapsePanel = (panel) => {
      if (!panel) return;
      panel.style.maxHeight = "0px";

      panel.addEventListener(
        "transitionend",
        (event) => {
          if (event.propertyName !== "max-height") return;
          if (header.classList.contains("hovering")) return;
          panel.style.display = "none";
        },
        { once: true }
      );
    };

    const closeSubnavs = () => {
      header.classList.remove("hovering");
      btns.forEach((b) => b.classList.remove("active"));

      subnavs.forEach((s) => {
        collapsePanel(s);
      });
    };

    const queueCloseSubnavs = () => {
      clearCloseTimer();
      closeTimer = window.setTimeout(closeSubnavs, CLOSE_DELAY);
    };

    const openSubnav = (btn) => {
      const panel = header.querySelector(
        `.subnav[data-subnav-id="${btn.dataset.subnavId}"]`
      );
      if (!panel) return;

      clearCloseTimer();

      // Set active to btn
      btns.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");

      // Add active state to header
      header.classList.add("hovering");

      // Hide all subnavs and show selected panel
      subnavs.forEach((s) => {
        if (s === panel) {
          s.style.display = "grid";
          setPanelHeight(s);
          // Force reflow so reopening after a collapsed state animates reliably.
          s.getBoundingClientRect();
          window.requestAnimationFrame(() => {
            s.style.maxHeight = "var(--subnav-height)";
          });
        } else {
          s.style.maxHeight = "0px";
          s.style.display = "none";
        }
      });
    };

    // Set up display interaction
    for (const btn of btns) {
      btn.addEventListener("pointerenter", () => openSubnav(btn));
    }

    if (subnavsOuter) {
      subnavsOuter.addEventListener("pointerenter", clearCloseTimer);
      subnavsOuter.addEventListener("pointerleave", queueCloseSubnavs);
    }

    header.addEventListener("pointerenter", clearCloseTimer);
    header.addEventListener("pointerleave", queueCloseSubnavs);
  }

  initAnnouncement();
  function initAnnouncement() {
    const announcement = document.querySelector(".announcement");

    // Guard
    if (!announcement) return;

    // Show announcement if closedCookie hasn't been set
    const closedCookie = Cookies.get("kesterblack-announcement-closed");
    if (closedCookie) return;
    announcement.style.display = "flex";

    const close = announcement.querySelector(".btn-close");

    // Observe height
    const resizer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const height = entry.target.scrollHeight;
        entry.target.style.setProperty("--height", height + "px");
      }
    });
    resizer.observe(announcement);

    // Add event
    close.addEventListener("click", () => {
      // Unobserve height changes
      resizer.unobserve(announcement);
      // Add closedCookie
      Cookies.set("kesterblack-announcement-closed", "true", { expires: 1 });

      // Add shrinking class
      announcement.classList.add("shrink");

      announcement.addEventListener(
        "transitionend",
        () => {
          announcement.style.display = "none";
        },
        { once: true }
      );
    });
  }

  // Toggle Mobile Menu
  mobileMenuToggle();
  function mobileMenuToggle() {
    const btn = header.querySelector("[kb-menu-toggle]");
    const menu = header.querySelector("[data-mobile-menu]");
    if (!btn || !menu) return;

    const views = menu.querySelectorAll("[data-menu-view]");
    const details = menu.querySelectorAll("details");
    const mobileDetails = menu.querySelectorAll(".mobile-menu-details");

    const getDetailsContent = (detail) =>
      Array.from(detail.children).find((child) => child.tagName === "UL");

    const setDetailOpen = (detail, isOpen, animate = true) => {
      const content = getDetailsContent(detail);

      if (!content || detail.open === isOpen) {
        detail.open = isOpen;
        return;
      }

      if (!animate) {
        detail.open = isOpen;
        content.style.height = "";
        detail.classList.remove("is-animating");
        return;
      }

      detail.classList.add("is-animating");

      if (isOpen) {
        detail.open = true;
        content.style.height = "0px";
        requestAnimationFrame(() => {
          content.style.height = `${content.scrollHeight}px`;
        });
      } else {
        content.style.height = `${content.scrollHeight}px`;
        requestAnimationFrame(() => {
          content.style.height = "0px";
        });
      }

      content.addEventListener(
        "transitionend",
        (event) => {
          if (event.propertyName !== "height") return;

          if (!isOpen) detail.open = false;
          content.style.height = "";
          detail.classList.remove("is-animating");
        },
        { once: true }
      );
    };

    const openDefaultDetails = (name) => {
      const view = menu.querySelector(`[data-menu-view="${name}"]`);
      const defaultDetail = view?.querySelector("[data-menu-default-open]");
      if (defaultDetail) setDetailOpen(defaultDetail, true, false);
    };

    const activateView = (name = "root") => {
      views.forEach((view) => {
        const isActive = view.dataset.menuView === name;
        view.classList.toggle("is-active", isActive);
        view.setAttribute("aria-hidden", isActive ? "false" : "true");
      });
      openDefaultDetails(name);
    };

    const closeDetails = () => {
      details.forEach((detail) => detail.removeAttribute("open"));
    };

    const closeSearch = () => {
      const search = header.querySelector("predictive-search.sticky");
      header.classList.remove("search-active");
      if (!search) return;
      search.classList.remove("active");
      search.querySelector("#predictive-search")?.classList.remove("active");
    };

    const setMenuOpen = (isOpen) => {
      header.classList.toggle("mob-menu-open", isOpen);
      document.body.classList.toggle("mob-menu-is-open", isOpen);
      menu.setAttribute("aria-hidden", isOpen ? "false" : "true");
      btn.setAttribute("aria-expanded", isOpen.toString());
      btn.innerHTML = isOpen ? "Close" : "Menu";

      if (isOpen) {
        closeSearch();
      } else {
        activateView("root");
        closeDetails();
      }
    };

    activateView("root");

    btn.addEventListener("click", () => {
      setMenuOpen(!header.classList.contains("mob-menu-open"));
    });

    menu.querySelectorAll("[data-menu-open]").forEach((viewBtn) => {
      viewBtn.addEventListener("click", () => {
        closeDetails();
        activateView(viewBtn.dataset.menuOpen);
      });
    });

    menu.querySelectorAll("[data-menu-back]").forEach((backBtn) => {
      backBtn.addEventListener("click", () => {
        activateView("root");
        closeDetails();
      });
    });

    mobileDetails.forEach((detail) => {
      const summary = detail.querySelector("summary");
      if (!summary) return;

      summary.addEventListener("click", (event) => {
        event.preventDefault();
        setDetailOpen(detail, !detail.open);
      });
    });

    header.querySelectorAll(".btn-search").forEach((searchBtn) => {
      searchBtn.addEventListener("click", () => setMenuOpen(false));
    });

    document.addEventListener("keyup", (event) => {
      if (event.key === "Escape") setMenuOpen(false);
    });
  }
}

window.setObservableHeight = (element) => {
  const resizer = new ResizeObserver((entries) => {
    for (let entry of entries) {
      const height = entry.target.scrollHeight;
      entry.target.style.setProperty("--height", height + "px");

      // console.log(height);
    }
  });

  return resizer.observe(element);
};
